import "/node_modules/sal.js/dist/sal.css";
import Typewriter from "typewriter-effect/dist/core";

import { useEffect, useRef, useState } from "react";
import { useRouter } from "next/router";
import { useModal } from "react-modal-hook";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { showAppModal } from "~/redux/actions/app";
import { fetchRandomTalentPosts } from "~/redux/actions/talent";
import PhoneSignupModal from "~/components/modal/PhoneSignupModal";
import PhoneSigninModal from "~/components/modal/PhoneSigninModal";
import WechatSigninModal from "~/components/modal/WechatSigninModal";
import WechatSignupModal from "~/components/modal/WechatSignupModal";
import NewJobModal from "~/components/modal/NewJobModal";
import NewJobModalV2 from "~/components/modal/NewJobModalV2";
import usePrefs from "~/hooks/usePrefs";

import sal from "sal.js";
import AppFooter from "../components/app/AppFooter";

import logo from "~/assets/web3/logo.png";
import logobg from "~/assets/web3/logo-bg.png";
import bg from "~/assets/web3/bg.jpg";
import bg2 from "~/assets/web3/bg2.jpg";
import bg3 from "~/assets/web3/bg3.png";
import s1 from "~/assets/web3/s1.png";
import s2 from "~/assets/web3/s2.png";
import s3 from "~/assets/web3/s3.png";
import s4 from "~/assets/web3/s4.png";
import s5 from "~/assets/web3/s5.png";
import s6 from "~/assets/web3/s6.png";
import s7 from "~/assets/web3/s7.png";
import s8 from "~/assets/web3/s8.png";
import sv1 from "~/assets/web3/sv1.png";
import sv2 from "~/assets/web3/sv2.png";
import sv3 from "~/assets/web3/sv3.png";
import sv4 from "~/assets/web3/sv4.png";
import l1 from "~/assets/web3/logo/1.png";
import l2 from "~/assets/web3/logo/2.png";
import l3 from "~/assets/web3/logo/3.png";
import l4 from "~/assets/web3/logo/4.png";
import l5 from "~/assets/web3/logo/5.png";
import l6 from "~/assets/web3/logo/6.png";
import l7 from "~/assets/web3/logo/7.png";
import l8 from "~/assets/web3/logo/8.png";
import l9 from "~/assets/web3/logo/9.png";
import l10 from "~/assets/web3/logo/10.png";
import l11 from "~/assets/web3/logo/11.png";
import l12 from "~/assets/web3/logo/12.png";
import l13 from "~/assets/web3/logo/13.png";
import l14 from "~/assets/web3/logo/14.png";

const MODALS = {
  PhoneSigninModal,
  PhoneSignupModal,
  WechatSigninModal,
  WechatSignupModal,
  NewJobModal,
  NewJobModalV2,
};

const modals = {};

const Page = (props) => {
  const [posts, setPosts] = useState(props.talentPosts);
  const router = useRouter();
  const { prefs } = usePrefs();

  const handleMoreOpenings = () => {
    window.location.href = "https://eleduck.com/categories/22/tags/89";
  };

  const fetchTalentPosts = async () => {
    const { posts } = await fetchRandomTalentPosts(7, "区块链&Web3");
    setPosts(posts);
  };

  const registerModal = (modalName, Modal) => {
    const [showModal, hideModal] = useModal(() => {
      return (
        <Modal
          hideModal={hideModal}
          isOpen
        />
      );
    });

    modals[modalName] = {
      showModal,
      hideModal: () => {
        hideModal();
        modals.current = null;
      },
    };
  };

  for (const modalName in MODALS) {
    registerModal(modalName, MODALS[modalName]);
  }

  useEffect(() => {
    const modalName = props.modal;
    if (modalName) {
      modals.current && modals.current.hideModal();
      modals.current = modals[modalName];
      modals.current.showModal();
      props.showAppModal(null);
    }
  }, [props.modal]);

  const handleLinkToNewPost = () => {
    if (!props.token) {
      props.showAppModal("PhoneSigninModal");
      return;
    }

    if (prefs.job_post_ui_version === "v2") {
      props.showAppModal("NewJobModalV2");
    } else {
      props.showAppModal("NewJobModal");
    }
  };

  useEffect(() => {
    const typewriter = new Typewriter("#web3-typewriter", {
      loop: true,
      cursor: "",
    });
    typewriter
      .pauseFor(300)
      .typeString("Web3")
      .pauseFor(2000)
      .deleteChars(4)
      .pauseFor(300)
      .typeString("Remote")
      .pauseFor(2000)
      .deleteChars(6)
      .start();
  }, []);

  return (
    <div
      className={`web3`}
      style={{ backgroundImage: `url(${bg3.src})` }}
    >
      <section
        className="header"
        onClick={() => {
          router.push("/");
        }}
      >
        <img
          alt="web3"
          src={logo.src}
          width="136px"
          height="40px"
        />
        <ul>
          <li>
            <a
              className="active"
              href="/"
            >
              Jobs
            </a>
          </li>
          <li>
            <a href="">Learn</a>
          </li>
          <li className="mb-hidden">
            <a href="https://eleduck.com/categories/19">COMMUNITY</a>
          </li>
        </ul>
      </section>
      <section
        className="section-1"
        style={{ backgroundImage: `url(${bg.src})` }}
      >
        <h1>
          从这里，开始 <span id="web3-typewriter"></span>
        </h1>
        <p className="p1">Start Web3&Remote Journey From Here.</p>
        <p className="p2">
          我们希望帮助更多人了解进入 web3
          的世界。从这里获得信息、资源、经验以及最重要的——工作机会。
        </p>
        <p className="p2">
          We love to help more people understand and enter the world of web3.
          Get information, resources, experience and, most importantly – job
          opportunities.
        </p>
        <div className="buttons">
          <div
            className="btn"
            onClick={() => {
              window.location.href =
                "https://eleduck.com/categories/22/tags/89";
            }}
          >
            找工作 Get Work
          </div>
          <div
            className="btn trans"
            onClick={handleLinkToNewPost}
          >
            发招聘 Start Hiring
          </div>
        </div>
        <div className="socials">
          <a href="https://discord.gg/pKTQTD5tEy">
            <img
              src={s1.src}
              width="32px"
            />
          </a>
          <a href="https://twitter.com/eleduck_com">
            <img
              src={s2.src}
              width="32px"
            />
          </a>
          <a href="https://t.me/+DTZgEmir6xZiOWI1">
            <img
              src={s3.src}
              width="32px"
            />
          </a>
          <a href="https://eleduck.com/groups">
            <img
              src={s7.src}
              width="32px"
            />
          </a>
        </div>
      </section>
      <section
        className="section-2"
        style={{ backgroundImage: `url(${bg2.src})` }}
      >
        <div className="stats">
          <div className="num">7000+</div>
          <div className="name">开发者</div>
          <div className="name-en">Developer</div>
        </div>
        <div className="stats">
          <div className="num">2000+</div>
          <div className="name">设计/产品/运营</div>
          <div className="name-en">Designers/PMs/OPs</div>
        </div>
        <div className="stats">
          <div className="num">500+</div>
          <div className="name">海外华人</div>
          <div className="name-en">Overseas Chinese</div>
        </div>
      </section>
      <section className="section-3">
        <img
          className="logo-bg"
          alt="bg"
          src={logobg.src}
        />
        <div className="title">
          <h1>正在招聘</h1>
          <h2>CURRENT OPENING</h2>
        </div>
        <div className="posts">
          {posts &&
            posts.map((p) => (
              <a
                className="post active"
                href={`/tposts/${p.id}`}
              >
                {p.title}
              </a>
            ))}
        </div>

        <div
          className="btn more"
          onClick={handleMoreOpenings}
        >
          More Openings
        </div>

        <div className="title">
          <h1>我们提供</h1>
          <h2>WHAT WE'RE OFFERING</h2>
        </div>
        <div className="desc">
          <p>精准高效的招聘服务</p>
          <p>Accurate and efficient recruitment services</p>
        </div>

        <div className="services">
          <div className="service">
            <img
              alt="sv1"
              src={sv1.src}
            />
            <div>
              <div className="t1">平均3-7天完成招聘</div>
              <div className="t2">
                Recruitment takes an average of 3-7 days to complete
              </div>
              <div className="t3">
                依托庞大人才库直接筛选高质量简历，匹配合适人才，高效快速。
              </div>
              <div className="t4">
                Relying on a vast talent pool to directly screen high-quality
                resumes, and match suitable talents, efficiently and fast.
              </div>
            </div>
          </div>
          <div className="service">
            <img
              alt="sv1"
              src={sv2.src}
            />
            <div>
              <div className="t1">简历匹配程度达70%</div>
              <div className="t2">70% CV match rate</div>
              <div className="t3">
                人才库HR会针对岗位需求，替公司做出更精准的简历初筛匹配。
              </div>
              <div className="t4">
                Talent pool HR will make a more accurate resume initial
                screening match according to the position's needs.
              </div>
            </div>
          </div>
          <div className="service">
            <img
              alt="sv1"
              src={sv3.src}
            />
            <div>
              <div className="t1">专人协助招聘</div>
              <div className="t2">
                Dedicated personnel to assist in the recruitment
              </div>
              <div className="t3">
                Web3行业专家+HR全程协助招聘，极大节省企业HR时间。
              </div>
              <div className="t4">
                Web3 industry experts + experienced HR assist in the entire
                recruitment process, significantly saving the company time.
              </div>
            </div>
          </div>
          <div className="service">
            <img
              alt="sv1"
              src={sv4.src}
            />
            <div>
              <div className="t1">费用极低，入职后付</div>
              <div className="t2">
                Meager service fees and pay after the successful recruitment.
              </div>
              <div className="t3">
                推荐入职成功后，仅收取半个月的薪资作为服务费用，远低猎头。
              </div>
              <div className="t4">
                After the successful candidate recommendation, only half a
                month's salary amount of the candidate will be charged as a
                service fee, which is much lower than headhunters.
              </div>
            </div>
          </div>
        </div>

        {/* <div className="title">
          <h1>合作伙伴</h1>
          <h2>PARTNERS</h2>
        </div>
        <div className="partners">
          <img className="partner" src={l11.src} />
          <img className="partner" src={l12.src} />
          <img className="partner" src={l13.src} />
          <img className="partner" src={l14.src} />
        </div> */}
      </section>
      <section className="section-4">
        <p>
          <a href="https://eleduck.com">WWW.ELEDUCK.COM</a>
        </p>
        <p>© 2014-2022</p>
        <div>
          <a href="https://discord.gg/pKTQTD5tEy">
            <img
              className="s"
              src={s4.src}
              height="32px"
            />
          </a>
          <a href="https://twitter.com/eleduck_com">
            <img
              className="s"
              src={s5.src}
              height="32px"
            />
          </a>
          <a href="https://t.me/+DTZgEmir6xZiOWI1">
            <img
              className="s"
              src={s6.src}
              height="32px"
            />
          </a>
          <a href="https://eleduck.com/groups">
            <img
              className="s"
              src={s8.src}
              height="32px"
            />
          </a>
        </div>
      </section>
      <AppFooter />
    </div>
  );
};

const mapStateToProps = (state) => ({
  token: state.user.token,
  modal: state.app.modal,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      showAppModal,
    },
    dispatch
  );

Page.getInitialProps = async (ctx) => {
  const { posts: talentPosts } = await fetchRandomTalentPosts(7, "区块链&Web3");
  return {
    talentPosts,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Page);
